import React, { useContext, useState, useEffect } from "react";
import { Button, Input } from "antd";
import { FaArrowLeft } from 'react-icons/fa';
import axios from "axios";
import { AuthContext } from "../../../../contexts/AuthContext";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import LoadingAction from "../../../../themes/LoadingAction/LoadingAction";

const AddMaquina = (props) => {

  const styles = `
  .Maquinas-page {
  background-color: black;
  color: white; 
  margin: 0; 
  padding: 0; 
  height: 100vh;
  height: 100dvh;
  min-height: 100vh;
  min-height: 100dvh;
  width: 100vw;
  overflow: auto;
  }
  .AddMaquina_header {
    display: flex; 
    align-items: center; 
    justify-content: flex-start; 
    margin: 10px 20px 20px 20px; 
    padding: 0; 
    gap: 20px; 
  }
  .AddMaquina_header_title {
  background-color: transparent !important;
  color: rgb(250, 247, 83) !important;
  border-radius: 5px !important;
  display: flex; 
  align-items: center; 
  justify-content: center;
  text-align: center;
  height: auto; 
  font-size: 30px;
  margin-top: 50px;
  }
  .Botao-Voltar {
  font-size: 20px;
  padding: 20px; 
  display: flex; 
  align-items: center; 
  justify-content: center;
  text-align: center;
  border-radius: 10px;
  border: none;
  font-weight: bold;
  background-color: rgb(163, 3, 163);
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 50px;
  border: 1px solid #ffffff;
  }
  .Botao-Voltar:hover {
  background-color: rgb(250, 31, 250);
  }
  .AddMaquina_content {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 400px;
    padding: 30px;
  }
  .AddMaquina_itemField {
    padding: 5px;
    width: 100%;
  }
  .AddMaquina_itemFieldLabel {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
  }
  .AddMaquina_itemField input {
    border-radius: 4px;
    background-color: rgba(252, 249, 249, 0.99);
  }
  .AddMaquina_itemField .ant-picker {
    border-radius: 4px;
     background-color: rgba(252, 249, 249, 0.99);
  }
  .AddMaquina_itemField .ant-picker-input {
    border: none;
    border-radius: 0;
    background-color: transparent;
  }
  .AddMaquina_itemField .ant-picker-focused .ant-picker-input {
    box-shadow: none;
  }
  .AddMaquina_itemField input .AddMaquina_inputError {
    border: 1px solid #e46772;
  }
  .Botao-Salvar {
    margin-top: 20px;
    background-color:rgb(6, 128, 2);
    color: #fff;
    border-radius: 4px;
    width: 100%;
    border: 1px solid #ffffff;
    display: flex; 
    align-items: center; 
    justify-content: center; 
    text-align: center;
    font-size: 20px;
    font-weight: bold;
  }
  .Botao-Salvar:hover {
    background-color:rgb(78, 247, 100);
    color: #fff;
  }
  .AddMaquina_itemFieldError {
    color: #e46772;
    font-size: 14px;
    padding: 2px 0;
  }
  .AddMaquina_Label_Icon {
    cursor: pointer;
    display: flex;
    align-items: center;
  }
  .AddMaquina_Icon {
    width: 22px;
    margin-left: 10px;
    margin-bottom: 0.5rem;
  }
  .AddMaquina_Reload_Icon {
    cursor: pointer;
  }
  @media only screen and (max-width: 760px) and (orientation: portrait) {
   .AddMaquina_header {
    display: flex;
    flex-direction: column; 
    align-items: center; 
    width: 100%; 
    gap: 10px;
    margin: 0;
    padding: 20px;
   }
   .AddMaquina_header_title {
    width: 100%; 
    text-align: center !important; 
    font-size: 28px; 
    margin: 0; 
    padding-bottom: 15px;
   }
   .Botao-Voltar {
    width: 100%; 
    margin: 0; 
    font-size: 22px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
  }
}

`;

    useEffect(() => {
      const styleSheet = document.createElement("style");
      styleSheet.type = "text/css";
      styleSheet.innerText = styles;
      document.head.appendChild(styleSheet);
  
      return () => {
        document.head.removeChild(styleSheet);
      };
    }, [styles]);

  const { authInfo, setNotiMessage } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  const token = authInfo?.dataUser?.token;

  const { id } = useParams();

  const [data, setData] = useState({
    nome: "",
    descricao: "",
    valorDoPix: "",
    store_id: "",
    valorDoPulso: "1",
    pulsotentativa: "2",
    estoque: "100",
    valpelucia: "20", // Pelucia
    limitetrava: "40", // Pelucia
    quantidade: "1", // Número de máquinas a serem criadas
    numerar: "1", //  Número inicial das novas máquinas
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (name, value) => {
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => {
      let errorsTemp = { ...prev };
      delete errorsTemp[name];
      return errorsTemp;
    });
  };

  const onSave = async () => {
    // Check for required fields
    let errorsTemp = {};
    if (data.nome.trim() === "") {
      errorsTemp.nome = "Este campo é obrigatório";
    }
    if (data.descricao.trim() === "") {
      errorsTemp.descricao = "Este campo é obrigatório";
    }
    if (data.valorDoPulso < 1) {
      errorsTemp.valorDoPulso = "Este campo é obrigatório 02";
    }

    if (data.store_id.trim() === "") {
      errorsTemp.store_id = "Este campo é obrigatório";
    }

    if (Object.keys(errorsTemp).length > 0) {
      setErrors(errorsTemp);
      return;
    }

    setIsLoading(true);

    const quantidade = parseInt(data.quantidade, 10);
    let numerar = parseInt(data.numerar, 10); // valor inicial para numerar

    // Logando a sequência de numeração
    console.log(`Iniciando a criação de ${quantidade} máquinas com a numeração inicial: ${numerar}`);

    for (let i = 0; i < quantidade; i++) {
      const nomeMaquina = `${data.nome} ${numerar}`;
      const descricaoMaquina = `${data.descricao} ${numerar}`;

      // Logando o nome e descrição antes de enviar
      // console.log(`Criando máquina ${i + 1} de ${quantidade}:`);
      // console.log(`Nome: ${nomeMaquina}`);
      //  console.log(`Descrição: ${descricaoMaquina}`);

      try {
        // Esperando uma requisição ser concluída antes de seguir para a próxima
        await axios.post(
          `${process.env.REACT_APP_SERVIDOR}/maquina`,
          {
            clienteId: id.trim(),
            nome: nomeMaquina,
            descricao: descricaoMaquina,
            valorDoPulso: data.valorDoPulso,
            valorDoPix: data.valorDoPix,
            store_id: data.store_id.trim(),
            estoque: Number(data.estoque),
            valpelucia: Number(data.valpelucia), // Pelucia
            pulsotentativa: Number(data.pulsotentativa), // Pelucia
            limitetrava: Number(data.limitetrava), // Pelucia
          },
          {
            headers: {
              "x-access-token": token,
              "content-type": "application/json",
            },
          }
        );
        // Logando sucesso após cada requisição
        // console.log(`Máquina ${numerar} criada com sucesso`);
        numerar += 1; // Incrementa numerar após cada máquina
      } catch (err) {
        console.error(`Erro ao criar máquina ${numerar}: ${err.response?.data?.error || err.message}`);
        break; // Para caso haja erro, você pode decidir se quer parar a criação
      }
    }

    setIsLoading(false);
    setNotiMessage("Máquinas criadas com sucesso!");
    setTimeout(() => {
      navigate(`/cliente-maquinas/${id}`, {
        state: location.state,
      });
    }, 1000);
  };

  return (
    <>
      {isLoading && <LoadingAction />}
      <div className="Maquinas-page ">
        <div className="AddMaquina_header">
          <div className="AddMaquina_header_title">ADICIONAR MÁQUINA</div>
          <Button
            className="Botao-Voltar"
            onClick={() =>
              navigate(`/cliente-maquinas/${id}`, {
                state: location.state,
              })
            }
          >
            <FaArrowLeft />
            VOLTAR
          </Button>
        </div>

        <div className="AddMaquina_content">
          <div className="AddMaquina_itemField">
            <label className="AddMaquina_itemFieldLabel" htmlFor="nome">
              Nome:
            </label>
            <Input
              placeholder={"Máquina de alguém"}
              value={data.nome}
              id="nome"
              type="text"
              name="nome"
              autoComplete="nome"
              onChange={(event) => handleChange("nome", event.target.value)}
              className={`${!!errors.nome ? "AddMaquina_inputError" : ""}`}
            />
            {errors.nome && (
              <div className="AddMaquina_itemFieldError">{errors.nome}</div>
            )}
          </div>

          <div className="AddMaquina_itemField">
            <label className="AddMaquina_itemFieldLabel" htmlFor="descricao">
              Descricao:
            </label>
            <Input
              placeholder={"Está em algum lugar"}
              value={data.descricao}
              id="descricao"
              type="text"
              name="descricao"
              autoComplete="descricao"
              onChange={(event) => handleChange("descricao", event.target.value)}
              className={`${!!errors.descricao ? "AddMaquina_inputError" : ""}`}
            />
            {errors.descricao && (
              <div className="AddMaquina_itemFieldError">{errors.descricao}</div>
            )}
          </div>

          <div className="AddMaquina_itemField">
            <label className="AddMaquina_itemFieldLabel" htmlFor="store_id">
              Store_id:
            </label>
            <Input
              placeholder={"12345678"}
              value={data.store_id}
              id="store_id"
              type="number"
              name="store_id"
              autoComplete="store_id"
              onChange={(event) => handleChange("store_id", event.target.value)}
              className={`${!!errors.store_id ? "AddMaquina_inputError" : ""}`}
            />
            {errors.store_id && (
              <div className="AddMaquina_itemFieldError">{errors.store_id}</div>
            )}
          </div>

          <div className="AddMaquina_itemField">
            <label className="AddMaquina_itemFieldLabel" htmlFor="valorDoPulso">
              Valor em Reais para dar 01 Pulso:
            </label>
            <Input
              placeholder={"1"}
              value={data.valorDoPulso}
              id="valorDoPulso"
              type="number"
              name="valorDoPulso"
              autoComplete="valorDoPulso"
              onChange={(event) => handleChange("valorDoPulso", event.target.value)}
              className={`${!!errors.valorDoPulso ? "AddMaquina_inputError" : ""}`}
            />
            {errors.valorDoPulso && (
              <div className="AddMaquina_itemFieldError">{errors.valorDoPulso}</div>
            )}
          </div>

          <div className="AddMaquina_itemField">
            <label className="AddMaquina_itemFieldLabel" htmlFor="pulsotentativa">
              Valor em Reais para 01 Tentativa:
            </label>
            <Input
              placeholder={"2"}
              value={data.pulsotentativa}
              id="pulsotentativa"
              type="number"
              name="pulsotentativa"
              autoComplete="pulsotentativa"
              onChange={(event) => {
                handleChange("pulsotentativa", event.target.value);
              }}
              className={`${!!errors.pulsotentativa ? "AddMaquina_inputError" : ""
                }`}
            />
            {errors.pulsotentativa && (
              <div className="AddMaquina_itemFieldError">
                {errors.pulsotentativa}
              </div>
            )}
          </div>

          <div className="AddMaquina_itemField">
            <label className="AddMaquina_itemFieldLabel" htmlFor="valpelucia">
              Valor em Reais Da Pelúcia:
            </label>
            <Input
              placeholder={"20"}
              value={data.valpelucia}
              id="valpelucia"
              type="number"
              name="valpelucia"
              autoComplete="valpelucia"
              onChange={(event) => {
                handleChange("valpelucia", event.target.value);
              }}
              className={`${!!errors.valpelucia ? "AddMaquina_inputError" : ""
                }`}
            />
            {errors.valpelucia && (
              <div className="AddMaquina_itemFieldError">
                {errors.valpelucia}
              </div>
            )}
          </div>

          <div className="AddMaquina_itemField">
            <label className="AddMaquina_itemFieldLabel" htmlFor="limitetrava">
              Limite da Trava:
            </label>
            <Input
              placeholder={"40"}
              value={data.limitetrava}
              id="limitetrava"
              type="number"
              name="limitetrava"
              autoComplete="limitetrava"
              onChange={(event) => {
                handleChange("limitetrava", event.target.value);
              }}
              className={`${!!errors.limitetrava ? "AddMaquina_inputError" : ""
                }`}
            />
            {errors.limitetrava && (
              <div className="AddMaquina_itemFieldError">
                {errors.limitetrava}
              </div>
            )}
          </div>

          <div className="AddMaquina_itemField">
            <label
              className="AddMaquina_itemFieldLabel"
              htmlFor="estoque"
            >
              Estoque:
            </label>
            <Input
              placeholder={"100"}
              value={data.estoque}
              id="estoque"
              type="number"
              name="estoque"
              autoComplete="estoque"
              onChange={(event) => {
                handleChange("estoque", event.target.value);
              }}
              className={`${!!errors.estoque ? "AddMaquina_inputError" : ""
                }`}
            />
            {errors.estoque && (
              <div className="AddMaquina_itemFieldError">
                {errors.estoque}
              </div>
            )}
          </div>

          <div className="AddMaquina_itemField">
            <label className="AddMaquina_itemFieldLabel" htmlFor="quantidade">
              Quantidade de máquinas para criar de uma vez:
            </label>
            <Input
              placeholder={"1"}
              value={data.quantidade}
              id="quantidade"
              type="number"
              name="quantidade"
              autoComplete="quantidade"
              onChange={(event) => handleChange("quantidade", event.target.value)}
              className={`${!!errors.quantidade ? "AddMaquina_inputError" : ""}`}
            />
            {errors.quantidade && (
              <div className="AddMaquina_itemFieldError">{errors.quantidade}</div>
            )}
          </div>

          <div className="AddMaquina_itemField">
            <label className="AddMaquina_itemFieldLabel" htmlFor="numerar">
              Numero inicial para novas máquinas:
            </label>
            <Input
              placeholder={"1"}
              value={data.numerar}
              id="numerar"
              type="number"
              name="numerar"
              autoComplete="numerar"
              onChange={(event) => handleChange("numerar", event.target.value)}
              className={`${!!errors.numerar ? "AddMaquina_inputError" : ""}`}
            />
            {errors.numerar && (
              <div className="AddMaquina_itemFieldError">{errors.numerar}</div>
            )}
          </div>
          <Button
            className="Botao-Salvar"
            onMouseEnter={(e) => (e.target.style.color = "#fff")}
            onMouseLeave={(e) => (e.target.style.color = "#fff")}
            onClick={() => {
              onSave();
            }}
          >
            SALVAR DADOS
          </Button>
        </div>
      </div>
    </>
  );
};

export default AddMaquina;
